import React, { FC, Fragment } from 'react';
import styled from 'styled-components';
import { LeadQuestionnaireQuestionnaireStateProp, LeadQuestionnaireStateProp } from '../forms/ProductForm';
import { Checkbox } from '../general/forms/Checkbox';
import { AdditionalItemDivider } from './AdditionalListContentUI';

export interface AdditionalProductLeadQuestionnaireListContentProps {
  item: LeadQuestionnaireStateProp;
  onChange: (item: LeadQuestionnaireQuestionnaireStateProp) => void;
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const HeadWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
  justify-content: space-between;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
`;


const ResultSetsWrapper = styled.div`
 display: flex;
 flex-direction: column;
 width: 100%;
`;

const ResultSetWrapper = styled.div`
 display: flex;
 flex-direction: row;
 width: 100%;
 justify-content: space-between;
 margin: .5rem 0;
`;

const ResultSetLabel = styled.div`
  //
`;

export const AdditionalProductLeadQuestionnaireListContent: FC<AdditionalProductLeadQuestionnaireListContentProps> = (props) => {
  const { item, onChange } = props;
  return (
    <Wrapper>
      <HeadWrapper>
        <div>
          {
            item.questionnaires.length > 0 ?
              'Bitte wählen Sie die Fragebögen aus, die zu diesem Produkt angezeigt werden sollen.' :
              'Es wurden keine Lead-Fragebögen zu gefunden!'
          }
        </div>
      </HeadWrapper>
      <ContentWrapper>
        <ResultSetsWrapper>
          {
            item.questionnaires.length > 0 && item.questionnaires.map((questionnaire, index) => {
              return <Fragment key={index}>
                <ResultSetWrapper>
                  <ResultSetLabel>{questionnaire.label.replace('Lead:', '')}</ResultSetLabel>
                  <Checkbox checked={questionnaire.checked} id={questionnaire.id} onChange={(checked) => {
                    const result = { ...questionnaire, checked: checked };
                    onChange(result);
                  }} />
                </ResultSetWrapper>
                <AdditionalItemDivider />
              </Fragment>;
            })
          }
        </ResultSetsWrapper>
      </ContentWrapper>
    </Wrapper>
  );
};
